import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {NavigationContainer} from '@react-navigation/native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {rose} from '/theme/color/secondary.color';

import BottomTabNavigation from '../BottomTabNavigation';

const storyStyle = StyleSheet.create({
  bottomTabNavigationWrapper: {
    width: '100%',
    height: 300,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: rose,
  },
  tabView: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const Tab = ({route: {name}}: any) => (
  <View style={storyStyle.tabView}>
    <Text>{name}</Text>
  </View>
);

storiesOf('NO_SNAPSHOT/layout', module).add('BottomTabNavigation', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Bottom Tab Navigation</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>BottomTabNavigation</Code> component is used to render the
          app's main navigation layout.
        </Text>
        <Spacer size={16} />
        <Text>
          The tabs and their contents are passed into the{' '}
          <Code>BottomTabNavigation</Code> component via the <Code>tabs</Code>{' '}
          props.
        </Text>
        <Spacer size={6} />
        <Code>{'tabs={['}</Code>
        <Code>{'  {'}</Code>
        <Code>{"    name: 'tab1',"}</Code>
        <Code>{"    activeIcon: 'dashboard-filled',"}</Code>
        <Code>{"    icon: 'dashboard',"}</Code>
        <Code>{"    label: 'Tab 1',"}</Code>
        <Code>{'    component: Tab1,'}</Code>
        <Code>{'  },'}</Code>
        <Code>{'  {'}</Code>
        <Code>{"    name: 'tab2',"}</Code>
        <Code>{"    activeIcon: 'team-filled',"}</Code>
        <Code>{"    icon: 'team',"}</Code>
        <Code>{"    label: 'Tab 2',"}</Code>
        <Code>{'    component: Tab2,'}</Code>
        <Code>{'  },'}</Code>
        <Code>{'  {'}</Code>
        <Code>{"    name: 'tab3',"}</Code>
        <Code>{"    activeIcon: 'clients-filled',"}</Code>
        <Code>{"    icon: 'clients',"}</Code>
        <Code>{"    label: 'Tab 3',"}</Code>
        <Code>{'    component: Tab3,'}</Code>
        <Code>{'  },'}</Code>
        <Code>{']}'}</Code>
        <Spacer size={16} />
        <NavigationContainer independent={true}>
          <View style={storyStyle.bottomTabNavigationWrapper}>
            <BottomTabNavigation
              tabs={[
                {
                  name: 'tab1',
                  activeIcon: 'dashboard-filled',
                  icon: 'dashboard',
                  label: 'Tab 1',
                  component: Tab,
                  onPress: () => {},
                },
                {
                  name: 'tab2',
                  activeIcon: 'team-filled',
                  icon: 'team',
                  label: 'Tab 2',
                  component: Tab,
                  onPress: () => {},
                },
                {
                  name: 'tab3',
                  activeIcon: 'clients-filled',
                  icon: 'clients',
                  label: 'Tab 3',
                  component: Tab,
                  onPress: () => {},
                },
              ]}
            />
          </View>
        </NavigationContainer>
      </FlexView>
    </Spacing>
  </ScrollView>
));
